<template>
  <div
    class="spa-reservation-summary"
    :class="{ '--cancelled': isReservationCancelled }"
  >
    <h2 class="spa-reservation-summary__title">
      {{ tc('spaSoft.reservationdetails.treatments') }}
    </h2>
    <div class="spa-reservation-summary__guests">
      <SpaGuestTreatments
        v-for="(guest, guestIndex) in reservationDetailsData.guestAvailabilities"
        :key="guestIndex"
        :guest-data="guest"
        :guest-number="Number(guestIndex) + 1"
      />
    </div>
    <div class="spa-reservation-summary__footer">
      <div class="spa-reservation-summary__taxes">
        <component
          :is="isMobile ? 'div' : 'button'"
          class="spa-reservation-summary__taxes-button"
          @click="isTaxesExpanded = !isTaxesExpanded"
        >
          <h4 class="spa-reservation-summary__taxes-title">
            {{ tc('spaSoft.step2.stayDetailsTaxesAndFees') }}
          </h4>
          <span class="spa-reservation-summary__taxes-amount">
            {{ getTotalTaxes({ formatted: true, isReservation: true }) }}
          </span>
          <span
            v-if="!isMobile"
            class="spa-reservation-summary__taxes-icon"
            :class="isTaxesExpanded ? 'icon-minus' : 'icon-add'"
          />
        </component>
        <transition name="expand-y">
          <div
            v-if="isTaxesExpanded || isMobile"
            class="spa-reservation-summary__taxes-details"
          >
            <div
              v-for="(taxItem, index) in getTaxesList({ isReservation: true })"
              :key="index"
              class="spa-reservation-summary__tax-list"
            >
              <div
                v-for="(tax, taxIndex) in taxItem.taxes"
                :key="taxIndex"
                class="spa-reservation-summary__tax-item"
              >
                <span class="spa-reservation-summary__tax-name">
                  {{ taxItem.treatmentName }} - {{ tax.name }} - {{ tax.rate }}%
                </span>
                <span class="spa-reservation-summary__tax-amount">
                  {{
                    getDisplayPrice({
                      price: tax.total,
                      withIsoCode: true,
                      fromCurrency: reservationDetailsData.propertyData.currency.isoCode,
                      toCurrency: orSelected(reservationDetailsData.propertyData.currency.isoCode)
                    })
                  }}
                </span>
              </div>
            </div>
          </div>
        </transition>
      </div>

      <div class="spa-reservation-summary__total">
        <h4 class="spa-reservation-summary__total-title">
          {{ tc('spaSoft.step2.stayDetailsEstimatedCost') }}:
        </h4>
        <span class="spa-reservation-summary__total-amount">
          {{ getTotalCost({ formatted: true, isReservation: true }) }}
        </span>
      </div>
      <!-- TODO: Disabled temporary because of the payment not implemented in checkout -->
      <!-- <div class="spa-reservation-summary__payment">
        <p class="spa-reservation-summary__payment-text">
          Payment Held by Card
        </p>
        <div class="spa-reservation-summary__card-info">
          <span class="spa-reservation-summary__card-icon icon-cc-generic" />
          <span class="spa-reservation-summary__card-number">Card ending in 2345</span>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import SpaGuestTreatments from './spa-guest-treatments.vue'

  export default {
    name: 'SpaReservationSummary',
    components: {
      SpaGuestTreatments,
    },
    data() {
      return {
        isTaxesExpanded: false,
      }
    },
    computed: {
      ...mapState('responsive', ['width']),
      ...mapState('spaSoft', ['reservationDetailsData']),
      ...mapGetters('currency', ['getDisplayPrice', 'orSelected']),
      ...mapGetters('spaSoft', ['isReservationCancelled', 'getTotalCost', 'getTotalTaxes', 'getTaxesList']),
      ...mapGetters('i18n', ['tc']),
      isMobile() {
        return this.width <= 1024
      }
    },
  }
</script>
